import React, { useState } from 'react';
import classNames from 'classnames';
import { useTranslations, useStyles, useUserLanguage } from "examsbook-react-sdk/custom-hooks";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { useNavigate } from "react-router-dom";

/**
 * Instructions block.
 * @param props
 * @returns {*}
 * @constructor
 */
function InstructionBlock(props) {
    const [ showInstructions, setShowInstructions ] = useState(true);
    const { language, setUserLanguage } = useUserLanguage();
    const navigate = useNavigate();
    const classes = useStyles(styles)();
    const t = useTranslations();

    const { quizIsStarted, startQuiz, quiz } = props;
    const quizName = quiz.locales && quiz.locales[language] ? quiz.locales[language].name : quiz.name;
    const backToInstruction = () => {
        setShowInstructions(false);
    };

    const backToQuestion = () => {
        setShowInstructions(true);
    };

    const languageChange = (event) => {
        setUserLanguage(event.target.value);
    };

    return (
        <>
            <div className={classNames(classes.iBlock)}>
                <div className={classes.instructionsWebView}>
                    <h2>{quizName}</h2>
                    <div className={classes.questionCount}>
                        <div className={classes.questionContainer}>
                            <div className={classes.quesTag}>
                                <AccessAlarmIcon/>
                                <div>
                                    <span>{quiz.totalQuestions}</span>
                                    <h4>{t('Question')}</h4>
                                </div>
                            </div>
                            <div className={classes.quesTag}>
                                <AccessAlarmIcon/>
                                <div>
                                    <span>{quiz.duration} {t('MINUTS')}</span>
                                    <h4>{t('Duration')}</h4>
                                </div>
                            </div>
                            <div className={classes.quesTag}>
                                <AccessAlarmIcon/>
                                <div>
                                    <span>{parseFloat(quiz.mark).toFixed(2) || 0}</span>
                                    <h4>{t('Marks')}</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <>
                        <div className={classes.instructionText}>{t('General Instructions')}</div>
                        <ul>
                            <li>{t('YOU_WILL_GET_ONLY')}
                                <b> {t('ONE_ATTEMPT')}</b> {t('PLEASE_ENSURE_THAT_YOU_HAVE_RELIABLE_INTERNET')}
                            </li>
                            <li>{t('YOU')} <b>{t('CANNOT_PAUSE')}</b> {t('THE_TEST')}</li>
                            <li><b>{t('EVALUTE_ALL_OPTIONS_CAREFULLY')}</b></li>
                            <li>{t('THIS_TEST_HAS')}
                                 <b> {t('NEGATIVE_MARKING')}</b> {t('YOU_WILL_SEE_NEGATIVE_POSITIVE_NEGATIVE_MARK')}</li>
                        </ul>
                    </>
                    <div className={classes.selectLanguageContainer}>
                        <div className={classes.languageswitcher + ' ' + classes.languageswitcherWeb}>
                            <h4>{t('SELECT_LANGUAGE')}</h4>

                            <RadioGroup name="language" value={language} onChange={languageChange}>
                                <FormControlLabel value="en" control={<Radio/>} label="English" onClick={() => {
                                    setUserLanguage('en');
                                }}/>
                                <FormControlLabel value="hn" control={<Radio/>} label={t('hindi')} onClick={() => {
                                    setUserLanguage('hn');
                                }}/>
                            </RadioGroup>
                        </div>
                        <button type="button" onClick={startQuiz}>{t('START_TEST')}</button>
                    </div>
                </div>

            </div>
            <div className={classes.instructionsMobileView}>
                {showInstructions ?
                    <span className={classes.mobileBackHeader} onClick={() => navigate('/my-app')}>
             <ArrowBackIcon/>
           </span>
                    :
                    <span className={classes.mobileBackHeader} onClick={backToQuestion}>
             <ArrowBackIcon/>
           </span>
                }

                <h2>{quizName}</h2>
                {showInstructions ?
                    <div className={classes.questionCount}>
                        <div className={classes.questionContainer}>
                            <div className={classes.quesTag}>
                                <AccessAlarmIcon/>
                                <div>
                                    <span>{quiz.totalQuestions}</span>
                                    <h4>{t('Question')}</h4>
                                </div>
                            </div>
                            <div className={classes.quesTag}>
                                <AccessAlarmIcon/>
                                <div>
                                    <span>{quiz.duration} mins</span>
                                    <h4>{t('Duration')}</h4>
                                </div>
                            </div>
                            <div className={classes.quesTag}>
                                <AccessAlarmIcon/>
                                <div>
                                    <span>{quiz.mark}</span>
                                    <h4>{t('Marks')}</h4>
                                </div>
                            </div>
                        </div>
                        <div className={classes.languageswitcher}>
                            <h4>{t('SELECT_LANGUAGE')}</h4>

                            <RadioGroup name="language" value={language} onChange={languageChange}>
                                <FormControlLabel value="en" control={<Radio/>} label="English" onClick={() => {
                                    setUserLanguage('en');
                                }}/>
                                <FormControlLabel value="hn" control={<Radio/>} label={t('hindi')} onClick={() => {
                                    setUserLanguage('hn');
                                }}/>
                            </RadioGroup>
                        </div>
                    </div>
                    :
                    <>
                        <div className={classes.instructionText}>{t('Instructions')}</div>
                        <ul>
                            <li>
                                {t('QUIZ_INSTRUCTION_BLOCK.POINT1')}
                            </li>
                            <li>{t('QUIZ_INSTRUCTION_BLOCK.POINT2')}</li>
                            <li><b>{t('Evaluate all options carefully.')}</b></li>
                            <li>
                                {t('QUIZ_INSTRUCTION_BLOCK.POINT4')}
                            </li>
                        </ul>
                    </>
                }
                {showInstructions ?
                    <button type="button" onClick={backToInstruction}>{t('NEXT')} <ArrowBackIcon/></button> : ''}
                {!showInstructions && !quizIsStarted ?
                    <button type="button" onClick={startQuiz}>{t('START_TEST')}</button> : ''}
            </div>
        </>
    );
}

const styles = theme => ({
    iBlock: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: '#fff',
        height: '100vh',
        overflow: 'auto',
        '@media (max-width: 767px)': {
            display: 'none'
        }
    },
    instructionText: {
        color: '#008E76',
        fontSize: 14,
        paddingBottom: 25,
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold',
        '@media (min-width: 768px)': {
            fontSize: 18
        }
    },
    instructionsWebView: {
        width: '70%',
        margin: 'auto',
        '@media (min-width:768px) and (max-width: 1200px)': {
            width: '90%'
        },
        '& h2': {
            textAlign: 'center',
            width: '100%',
            fontSize: 16,
            color: '#000',
            margin: '25px 0',
        },
        '& ul': {
            listStyleType: 'disc',
            padding: '0 25px 90px',
            marginTop: 3,
            '& li': {
                fontSize: 13,
                color: '#000',
                marginBottom: 20,
                '@media (min-width: 768px)': {
                    fontSize: 14
                }
            }
        },
    },
    selectLanguageContainer: {
        display: 'flex',
        alignItems: 'center',
        position: 'fixed',
        bottom: 0,
        left: 0,
        margin: 'auto',
        right: 0,
        width: '70%',
        padding: '10px 0',
        borderTop: '1px solid #ddd',
        justifyContent: 'space-between',
        background: '#fff',
        '@media (min-width:768px) and (max-width: 1200px)': {
            width: '90%'
        },
        '& button': {
            position: 'static',
            display: 'flex',
            background: '#00BFA5',
            color: '#fff',
            padding: '10px 20px',
            fontSize: 14,
            outline: 'none',
            cursor: 'pointer',
            boxShadow: 'none',
            border: 0,
            borderRadius: 5,
            justifyContent: 'center',
            letterSpacing: '2px',
            alignItems: 'center',
            '& > svg': {
                marginLeft: 4,
                width: 20,
                height: 20,
                transform: 'rotate(180deg)',
                color: '#fff'
            }
        }
    },
    instructionsMobileView: {
        display: 'none',
        '@media (max-width: 767px)': {
            display: 'flex',
            flexDirection: 'column',
            '& h2': {
                textAlign: 'center',
                width: '100%',
                fontSize: 16,
                color: '#000',
                margin: '25px 0',
            },
            '& ul': {
                listStyleType: 'disc',
                padding: '0 25px',
                marginTop: 3,
                '& li': {
                    fontSize: 13,
                    color: '#000',
                    marginBottom: 20
                }
            },
            '& button': {
                position: 'fixed',
                bottom: 20,
                width: '90%',
                margin: 'auto',
                left: 0,
                right: 0,
                display: 'flex',
                background: '#00BFA5',
                textTransform: 'uppercase',
                color: '#fff',
                padding: '16px 0',
                fontSize: 14,
                outline: 'none',
                minHeight: '52px',
                boxShadow: 'none',
                border: 0,
                borderRadius: 5,
                justifyContent: 'center',
                letterSpacing: '2px',
                alignItems: 'center',
                '& > svg': {
                    marginLeft: 4,
                    width: 20,
                    height: 20,
                    transform: 'rotate(180deg)',
                    color: '#fff'
                }
            }
        }
    },
    mobileBackHeader: {
        '& svg': {
            color: '#757575',
            width: 26,
            height: 26,
        }
    },
    instructionsBackBtn: {
        float: 'left',
        width: '100%',
        lineHeight: '45px',
        textAlign: 'left',
        '& a': {
            display: 'inline-block',
            textDecoration: 'none',
            color: '#039be5',
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'underline',
            },
            '& img': {
                width: 20,
                display: 'inline-block',
                verticalAlign: 'text-bottom',
                marginRight: 3
            }
        }
    },
    questionContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        borderBottom: '1px solid #ddd',
        padding: '30px 0',
        marginBottom: 30
    },
    quesTag: {
        display: 'flex',
        alignItems: 'center',
        '& svg': {
            width: 26,
            height: 26,
            marginRight: 10,
            color: '#00BFA5',
            opacity: 0.5,
            '@media (min-width: 768px)': {
                opacity: 1
            }
        },
        '& div': {
            '& span': {
                color: '#000',
                fontSize: 14,
                fontWeight: 'bold',
                '@media (min-width: 768px)': {
                    fontSize: 16
                }
            },
            '& h4': {
                color: 'rgba(0,0,0,0.4)',
                fontWeight: 400,
                fontSize: 14,
                margin: 0,
                paddingTop: 5,
                '@media (min-width: 768px)': {
                    fontSize: 16
                }
            }
        }
    },
    languageswitcher: {
        '& h4': {
            margin: 0,
            fontWeight: 'bold',
            color: 'rgba(0,0,0,0.4)',
            fontSize: 12,
            marginBottom: 15,
            '@media (min-width: 768px)': {
                fontSize: 14
            },
            '& + div': {
                flexDirection: 'row',
                '& label': {
                    marginRight: 36,
                    '& span': {
                        fontSize: 14,
                        '@media (min-width: 768px)': {
                            fontSize: 14
                        },
                        '& svg': {
                            width: 22,
                            height: 22,
                            minWidth: 22
                        }
                    }
                },
                '& .MuiRadio-colorSecondary.Mui-checked': {
                    color: '#00BFA5'
                }
            }
        }
    },
    languageswitcherWeb: {
        display: 'flex',
        alignItems: 'center',
        '& h4': {
            marginBottom: 0,
            marginRight: 20
        }
    },

});
export default InstructionBlock;
